import desktopAnim from "../../../../../../img/key-features/planet-2.json";

export const keyFeatures = (lottie)=> {

    const loadLottieAnimations = () => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            const sections = document.querySelectorAll('.key-features');

            sections?.forEach(section => {
                const animWrapper = section.querySelector('.key-features__animation');

                if (animWrapper && !section._lottieAnimation) {
                    const animation = lottie.loadAnimation({
                        container: animWrapper,
                        renderer: 'svg',
                        loop: true,
                        autoplay: false,
                        animationData: desktopAnim,
                    });

                    animationPlay(animation);

                    const scrollHandler = () => {
                        animationPlay(animation);
                    };

                    window.addEventListener('scroll', scrollHandler);

                    // Зберігаємо посилання на анімацію і обробник події
                    section._lottieAnimation = { animation, scrollHandler };
                }
            });

            function animationPlay(animation) {
                const section = animation.wrapper.closest('.key-features');
                if (section && window.scrollY > ((section.getBoundingClientRect().top + window.scrollY) - (window.innerHeight / 1.33)) && window.scrollY < ((section.getBoundingClientRect().top + window.scrollY) + section.scrollHeight) - (window.innerHeight / 3)) {
                    animation.play();
                } else {
                    animation.pause();
                }
            }
        }
    };

    const destroyLottieAnimations = () => {
        const sections = document.querySelectorAll('.key-features');
        sections?.forEach(section => {
            const animData = section._lottieAnimation;
            if (animData) {
                animData.animation.destroy();
                window.removeEventListener('scroll', animData.scrollHandler);
                delete section._lottieAnimation;
            }
        });
    };

    loadLottieAnimations();

    window.addEventListener('resize', () => {
        destroyLottieAnimations();

        loadLottieAnimations();
    });
    
    
}